import { getApiBaseUrl } from '../config/api';

export type SecurityIncidentStatus = 'DRAFT' | 'CONFIRMED' | 'NOTIFICATION_SENT' | 'CLOSED';

export interface SecurityIncidentRow {
  id: string;
  title: string;
  description: string;
  status: SecurityIncidentStatus;
  confirmedAt: string | null;
  notificationSentAt: string | null;
  notificationLog: Array<Record<string, unknown>>;
  createdAt: string;
  updatedAt: string;
}

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export const incidentAdminService = {
  async listIncidents(): Promise<SecurityIncidentRow[]> {
    const res = await fetch(`${getApiBaseUrl()}/admin/incidents`, { headers: authHeaders() });
    if (!res.ok) throw new Error('Failed to load incidents');
    const body = await res.json();
    return body.incidents;
  },

  async createIncident(input: { title: string; description: string }): Promise<SecurityIncidentRow> {
    const res = await fetch(`${getApiBaseUrl()}/admin/incidents`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(input),
    });
    if (!res.ok) throw new Error('Failed to create incident');
    const body = await res.json();
    return body.incident;
  },

  async confirmIncident(id: string): Promise<SecurityIncidentRow> {
    const res = await fetch(`${getApiBaseUrl()}/admin/incidents/${id}/confirm`, {
      method: 'POST',
      headers: authHeaders(),
    });
    if (!res.ok) throw new Error('Failed to confirm incident');
    const body = await res.json();
    return body.incident;
  },

  async notifyIncident(id: string, operatorEmail: string): Promise<SecurityIncidentRow> {
    const res = await fetch(`${getApiBaseUrl()}/admin/incidents/${id}/notify`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ operatorEmail }),
    });
    if (!res.ok) throw new Error('Failed to trigger notification');
    const body = await res.json();
    return body.incident;
  },
};
